import Utils from '../utils';
const STORAGE_ENGINE = sessionStorage;
let CACHE_AUTH;

const UserInfoTool = {
    setToken(token) {
        STORAGE_ENGINE.setItem('_token', token);
    },

    // 获取用户Token
    getToken() {
        return STORAGE_ENGINE.getItem('_token');
    },

    setUser(user) {
        STORAGE_ENGINE.setItem('__user__', JSON.stringify(user));
    },

    // 获取用户信息
    getUser() {
        return JSON.parse(STORAGE_ENGINE.getItem('__user__'));
    },

    // 设置当前登录权限
    setAuth(authList = []) {
        CACHE_AUTH = Utils.deepClone(authList);
        STORAGE_ENGINE.setItem('__auth__', JSON.stringify(CACHE_AUTH));
    },

    // 获取当前登录用户权限
    getAuth() {
        // if (!CACHE_AUTH) {
        CACHE_AUTH = JSON.parse(STORAGE_ENGINE.getItem('__user__')).permissionList || [];
        // }
        return Utils.deepClone(CACHE_AUTH);
    },

    /**
     * 获取按钮权限
     * @param {String} moduleName
     * @param {String} subModuleName
     * @param {String} functionName
     */
    getButtonAuthByModule(moduleName, subModuleName, functionName) {
        try {
            const mod = CACHE_AUTH.find(auth => auth.name === moduleName);
            const subMod = mod.childList.find(auth => auth.name === subModuleName);
            const func = subMod.childList.find(auth => auth.name === functionName);
        } catch (error) {
            console.error(`Can't find permission of ${[moduleName, subModuleName, functionName].join(' > ')}`);
        }
    },

    clear() {
        STORAGE_ENGINE.clear();
    },

    logout() {
        this.clear();
    }
};

export default UserInfoTool;
